import React from "react";
import "./Projects.css";
const Projects = (props) => {
  return (
    <div className="project" id="projects">
      <h4>Projects</h4>
      <div className="procontainer">
        <div className="contentleft">
          <div className="school">
            <h6>Social-App</h6>
            <span>
              <b>Technology used:</b>
              Node.js , React.js , MongoDB , Redux ,Express.js
            </span>
            <div>
              <b>Features:</b>
              <ol>
                <li>user can create and login</li>
                <li>user can post and like</li>
                <li>user and non user can see posts</li>
              </ol>
            </div>
            <div>
              <a
                href="https://github.com/Rakib-RS/social-app"
                className="btn btn-primary"
                target="_blank"
              >
                <i className="fab fa-github fa-inverse"></i> Github Repo
              </a>
              <a
                href="https://social-app-connect.herokuapp.com/"
                style={{ float: "right" }}
                className="btn btn-primary"
                target="_blank"
              >
                Deployed here
              </a>
            </div>
          </div>
        </div>
        <div className="contentright">
          <div className="school">
            <h6>Movies App</h6>
            <span>
              <b>Technology used:</b>
              Node.js , React.js , MongoDB ,Express.js
            </span>
            <div>
              <b>Features:</b>
              <ol>
                <li>CRUD APP</li>
                <li>SORT Table</li>
              </ol>
            </div>
            <div>
              <a
                href="https://github.com/Rakib-RS/Movies-app"
                className="btn btn-primary"
                target="_blank"
              >
                <i className="fab fa-github fa-inverse"></i> Github Repo
              </a>
              <a
                href="https://movies-app-with-mern.herokuapp.com/"
                style={{ float: "right" }}
                className="btn btn-primary"
                target="_blank"
              >
                Deployed here
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="procontainer">
        <div className="contentleft">
          <div className="school">
            <h6>Re-vents</h6>
            <span>
              <b>Technology used:</b>
              Node.js , React.js , MongoDB , Redux ,Express.js
            </span>
            <div>
              <b>Features:</b>
              <ol>
                <li>event create</li>
              </ol>
            </div>
            <div>
              <a
                href="https://github.com/Rakib-RS/Re-vents"
                className="btn btn-primary"
                target="_blank"
              >
                <i className="fab fa-github fa-inverse"></i> Github Repo
              </a>
              <a
                href="https://re-vents-app.herokuapp.com/"
                style={{ float: "right" }}
                className="btn btn-primary"
                target="_blank"
              >
                Deployed here
              </a>
            </div>
          </div>
        </div>
        <div className="contentright">
          <div className="school">
            <h6>Kick Start</h6>
            <span>
              <b>Technology used:</b>
              Node.js , React.js , solidty, web3.js ,Express.js,Metamask
            </span>
            <div>
              <b>Features:</b>
              <ol>
                <li>Decentralized Application</li>
                <li>Only manager can create contratc</li>
                <li>Contributors can vote</li>
              </ol>
            </div>
            <div>
              <a
                href="https://github.com/Rakib-RS/kickstart"
                className="btn btn-primary"
                target="_blank"
              >
                <i className="fab fa-github fa-inverse"></i> Github Repo
              </a>
              <a
                href="#"
                style={{ float: "right" }}
                className="btn btn-primary"
                target="_blank"
              >
                Deployed here
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Projects;
